import { Component } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-mfr-card",
    templateUrl: "./mfr-card.component.html",
    styleUrls: ["./mfr-card.component.scss"],
})
export class MfrCardComponent extends CardComponent {
    constructor(public userService: UserService) {
        super(userService)
    }
}
